import { Controller } from '@hotwired/stimulus'

const LG_BREAKPOINT = 1024

export default class extends Controller<HTMLButtonElement> {
  triggerClicked(): void {
    if (window.innerWidth < LG_BREAKPOINT) {
      this.element.nextElementSibling?.classList.toggle('pointer-events-none')
      this.element.nextElementSibling?.classList.toggle('opacity-0')
      this.element.nextElementSibling?.classList.toggle('-translate-y-3')
    }
  }
}
